<template lang="html">
    <div id="auth">
        <form class="form" @submit.prevent="sendForm">
            <div class="form-group">
                <label>Please enter the 6 digit pin that we have just sent to your phone.</label>
                <input
                    maxlength="6"
                    data-cy="two_factor_pin"
                    type="text"
                    v-model="form.two_factor_pin"
                />
                <has-error
                    data-cy="two_factor_pin_error"
                    :form="form"
                    field="two_factor_pin"
                ></has-error>
            </div>

            <div class="form-group">
                <button
                    class="button dark"
                    :disabled="form.busy"
                    data-cy="submit"
                    type="submit"
                    name="button"
                >
                    {{ form.busy ? "Please wait" : "Verify" }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import Cookie from "js-cookie";
import { Form, HasError } from "vform";
import { ADMIN_LOGIN_MESSAGE, rejectAdminLogin } from "@/utils/rejectAdminLogin";
export default {
    name: "reset",
    components: { HasError },
    data() {
        return {
            form: new Form({
                two_factor_pin: "",
            }),
        };
    },
    methods: {
        sendForm() {
            this.form
                .post("/two-factor/auth")
                .then((response) => {
                    if (rejectAdminLogin(response.data)) {
                        return;
                    }

                    Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                    this.$store.state.user = response.data;
                    this.$router.push({ name: "Home" });
                })
                .catch((error) => {
                    const pinError = error.response?.data?.errors?.two_factor_pin;
                    const message = Array.isArray(pinError) ? pinError[0] : pinError;

                    if (
                        message === ADMIN_LOGIN_MESSAGE ||
                        message?.includes("nova") ||
                        message?.includes("admin panel")
                    ) {
                        this.form.errors.set("two_factor_pin", ADMIN_LOGIN_MESSAGE);
                        alert(ADMIN_LOGIN_MESSAGE);
                        return;
                    }

                    if (error.response?.status === 404) {
                        alert("Sorry that pin is incorrect or has expired");
                    }
                });
        },
    },
};
</script>

<style lang="less">
.form {
    .form-group {
        label {
            display: block;
        }
        input[type="text"],
        input[type="email"],
        input[type="password"] {
            width: 100%;
        }
    }
}
</style>
